import $ from 'jquery';
import eventManager from '~/js/managers/event-manager';


const Scroller = function () {
    let self, eventTypes, internal, elements, fn, handlers;

    self = this;

    eventTypes = {
        SCROLL: 'scrollerScroll'
    };

    internal = {
        scrollTop: 0,
        triggerTimeout: null
    };

    elements = {
        win: $(window),
        doc: $(document),
        scrollTarget: $('html, body')
    };

    fn = {
        init () {
            fn.updateScrollTop();
            fn.bindScrollEvent();
        },

        getScrollTarget () {
            return elements.scrollTarget;
        },

        getScrollTop () {
            return internal.scrollTop;
        },

        updateScrollTop () {
            internal.scrollTop = elements.doc.scrollTop();
        },

        bindScrollEvent () {
            elements.doc.on('scroll.scroller', handlers.scroll);
        },

        unbindScrollEvent () {
            elements.doc.off('scroll.scroller');
        },

        trigger () {
            fn.updateScrollTop();
            eventManager.emit(eventTypes.SCROLL, {
                scrollTop: internal.scrollTop
            });

            fn.triggerNative();
        },

        triggerNative () {
            // trigger native scroll event as a failsafe for more
            // complex computationals
            if (internal.triggerTimeout) {
                clearTimeout(internal.triggerTimeout);
                internal.triggerTimeout = null;
            }

            internal.triggerTimeout = setTimeout(function () {
                // ensure triggering the scroll event doesn't
                // cause a stack overflow
                fn.unbindScrollEvent();

                elements.doc.trigger('scroll');
                fn.bindScrollEvent();

                fn.updateScrollTop();
                eventManager.emit(eventTypes.SCROLL, {
                    scrollTop: internal.scrollTop
                });
            }, 500);
        },

        onScroll (handler) {
            return eventManager.addListener(eventTypes.SCROLL, handler);
        },

        offScroll (handler) {
            return eventManager.removeListener(eventTypes.SCROLL, handler);
        }
    };

    handlers = {
        scroll: fn.trigger
    };

    self.eventTypes = eventTypes;
    self.getScrollTarget = fn.getScrollTarget;
    self.getScrollTop = fn.getScrollTop;
    self.trigger = fn.trigger;
    self.onScroll = fn.onScroll;
    self.offScroll = fn.offScroll;

    fn.init();
};

export default new Scroller();



// WEBPACK FOOTER //
// ./assets/js/services/scroller.js